// separators for date format
export const Separators = ['/', '.', '-', ',', '@', '|'];

export default Separators;
